import { makeAutoObservable, runInAction } from "mobx";
import { rootContainer, TYPE } from "../../../services/container/root";
import DashboardService, { INotValidatedOwnerData } from "../../../services/api/dashboard-service";
import RmaCounterStore from "./rma-counters-store";
import IframeService from "../../../services/iframe-service/iframe-service";


class DashboardStore {
    private _isLoading: boolean = false;
    private _rmaCounters: RmaCounterStore[] = [];

    private _isLoadingNotVerifiedOwnerData: boolean = false;
    private _notVerifiedOwnerData?: INotValidatedOwnerData;


    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private get _dashboardService(): DashboardService { return rootContainer.get<DashboardService>(TYPE.DashboardService); }
    private get _iframeService(): IframeService { return rootContainer.get<IframeService>(TYPE.IframService); }

    public get isLoading(): boolean { return this._isLoading; }
    public get rmaCounters(): RmaCounterStore[] { return this._rmaCounters; }
    
    public get notVerifiedOwnerMessage(): string|undefined { return this._notVerifiedOwnerData?.message; }
    public get isLoadedNotVerifiedOwnerData(): boolean { return this._isLoadingNotVerifiedOwnerData; }

    public async load() {
        this._isLoading = true;
        try {
            const rma_counters = await this._dashboardService.fetchRMACounters();
            runInAction(() => {
                this._rmaCounters = rma_counters.map((counter) => {
                    return new RmaCounterStore(counter)
                });
                this._isLoading = false;
            });
        } catch (error) {
            console.error(error);
            runInAction(() => {
                this._isLoading = false;
            });
        }
    }

    public async loadNotVerifiedOwnerData() {
        this._isLoadingNotVerifiedOwnerData = true;
        try {
            const response = await this._dashboardService.fetchNotVerifiedOwnerData();
            runInAction(() => {
                this._notVerifiedOwnerData = response;
                this._isLoadingNotVerifiedOwnerData = false;
            });
        } catch (error) {
            console.error(error);
            runInAction(() => {
                this._isLoadingNotVerifiedOwnerData = false;
            });
        }
    }

    public async openChat(): Promise<void> {
        await this._iframeService.openParentIframeChat();
    }
}

export default new DashboardStore();